import format from 'date-fns/format';
import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import DataTable from 'components/CncUI/DataTable';

const Errors = props => {
  const { errors } = props;

  const parseDate = item =>
    format(parseInt(item.date, 10), 'MMM, do yyyy h:mm a');

  const columns = [
    { field: 'date', value: parseDate },
    { field: 'ids', label: 'Plaid Support' },
    { field: 'institution', label: 'Bank Institution' },
    { field: 'status', label: 'Error Status' },
    { field: 'error', label: 'Error Description' },
  ];

  const parseIds = item => (
    <div>
      <strong>link_session_id: </strong>
      {item.linkSessionId} <br />
      <strong>request_id: </strong>
      {item.requestId}
    </div>
  );

  const parseInstitution = item =>
    (JSON.parse(item.data).institution || {}).name;
  const parseStatus = item => (item.status || '').replace(/_/g, ' ');
  const parseError = item =>
    (JSON.parse(item.data).error || {}).display_message;

  const rows = errors.map(item => ({
    date: item.createdAt,
    ids: parseIds(item),
    institution: parseInstitution(item),
    status: parseStatus(item),
    error: parseError(item),
  }));

  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <Typography variant="h5">Plaid Errors</Typography>
      </Grid>
      <Grid item xs={12}>
        <DataTable
          transparent
          data={rows}
          columns={columns}
          sort="date"
          order="desc"
          emptyRows="No plaid errors to display"
        />
      </Grid>
    </Grid>
  );
};

export default Errors;
